import './CardPage.css';

function CardPage({ className, children }) {
  return (
    <section className={['card-page', className].filter(Boolean).join(' ')}>{children}</section>
  );
}

export default CardPage;
